import React from 'react';
import { PageFrame } from '../components/PageFrame';
import { faqs } from '../components/marketingContent';

type Props = {
  onPrimaryCta: () => void;
  onSecondaryCta: () => void;
};

export function FAQPage({ onPrimaryCta, onSecondaryCta }: Props) {
  return (
    <PageFrame title="FAQ" onPrimaryCta={onPrimaryCta} onSecondaryCta={onSecondaryCta}>
      <section id="faq" className="section">
        <div className="container">
          <div className="section-heading">
            <div>
              <h1 className="section-title">FAQ</h1>
              <h2 className="section-subtitle">Answers for desks, compliance, and ops.</h2>
            </div>
            <p className="section-description">
              If you need something custom - private webhooks, IP allowlists, or SOC2 paperwork - let us know when you
              onboard and we will set it up.
            </p>
          </div>
          <div className="faq-grid">
            {faqs.map((faq) => (
              <div className="faq-item" key={faq.q}>
                <h4>{faq.q}</h4>
                <p>{faq.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PageFrame>
  );
}
